import { provideSingleton } from '@v2/utilities/di/provide-singleton';
import { filterIsTruthy } from '@v2/utilities/pure-utils/filter-is-truthy';
import { CpApi, provideCpApi } from '../api-access/cp-api/cp-api';
import { cpGetUserInfo } from '../api-access/cp-api/cp-user-api/cp-get-user-info';
import { cpGetUserInfoDetails } from '../api-access/cp-api/cp-user-api/cp-get-user-info-details';
import { CpUserInfo } from '../api-access/cp-api/models/cp-user-info';
import { CpUserInfoDetails } from '../api-access/cp-api/models/cp-user-info-details';
import { CpUserDataInfo, provideCpUserDataInfo } from './cp-user-data-info';

export class CpUserInfoChecker {
  constructor(
    private _cpUserDataInfo: CpUserDataInfo,
    private _cpApi: CpApi
  ) {
    this._cpUserDataInfo
      .isLoggedIn()
      .pipe(filterIsTruthy())
      .subscribe(() => {
        this._initInfoDetails();
      });
  }

  public async init(): Promise<void> {
    const userInfo: CpUserInfo | undefined = await cpGetUserInfo(this._cpApi);

    this._cpUserDataInfo.userInfo$.next(userInfo);
  }

  private async _initInfoDetails(): Promise<void> {
    const userInfoDetails: CpUserInfoDetails | undefined = await cpGetUserInfoDetails(this._cpApi);
    this._cpUserDataInfo.userInfoDetails$.next(userInfoDetails);
  }
}

export function provideCpUserInfoChecker(): CpUserInfoChecker {
  return provideSingleton(CpUserInfoChecker, () => new CpUserInfoChecker(provideCpUserDataInfo(), provideCpApi()));
}
